// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".white-label-report .form-label {\n  color: #424747;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 40px;\n}\n.white-label-report .form-description {\n  color: #abadad;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  padding-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
